<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-nosize title" *ngIf="payload?.properties.text?.value">
  <label class="flex jcc">{{ payload?.properties.text?.value }}</label>
</div>
<div class="content-wp">
  <div class="content" *ngFor="let group of payload?.properties?.value; let idx = index">
    <div class="div-section">
      <div class="section-background">
        {{ group.section.value }}
      </div>
    </div>
    <div class="div-content" [innerHTML]="group.content.value"></div>
  </div>
</div>
